import { useEffect, useState } from "react";

/**
 * The current time, refreshed every `intervalMs` — for "12 min ago" labels that should keep
 * counting while the page stays open.
 */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
